module.exports = __webpack_public_path__ + "media/directory/skill_icon-d6032e2c.svg";